<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-payment">
      <div class="search-hd">
        <el-form :inline="true" @submit.native.prevent>
          <!-- 配置项 -->
          <el-form-item style="float: right; margin-right: 0">
            <custom-column :code="tableCode" v-model="tableColumn"></custom-column>
          </el-form-item>
          <el-form-item style="float: right">
            <div class="total-line">
              {{ i18n.page_content_total }}： {{ i18n.page_content_Party_B_shall_pay }}：{{ firstTotal }} {{ i18n.page_content_Party_A_representative_pays_to_factory }}：{{ hqProfitTotal }}
              {{ i18n.page_content_Party_A_representative_shall_deal_with_after_sales }}：{{ serviceProfitTotal }}
            </div>
          </el-form-item>
        </el-form>
      </div>
      <contract-payment-table :data="schemeList"></contract-payment-table>
      <el-form @submit.native.prevent style="margin-top: 20px">
        <div class="form-label">
          <el-form-item :label="i18n.label_payment_has_been_paid" prop="isPrepayment">
            <el-radio-group v-model="form.isPrepayment">
              <el-radio label="0">{{i18n.com_no}}</el-radio>
              <el-radio label="1">{{i18n.com_yes}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.isPrepayment === '1'">
            <el-button type="primary" @click="addPayMent">
              <i class="icon icon-add"></i>
              {{ i18n.page_content__register_payment_information }}
            </el-button>
          </el-form-item>
        </div>
        <custom-table v-if="form.isPrepayment === '1'" ref="table" :data="paymentList" :loading="isLoading" :column="tableColumn" :slots="['attachIdList']">
          <template slot="attachIdList" slot-scope="scope">
            <!-- <p>{{ i18n.page_content_productCode }}：{{ scope.row.productCode }}</p> -->
            <el-button type="text" size="mini" @click="onViewCredentials(scope.row)">{{i18n.com_detail}}</el-button>
          </template>
          <el-table-column :label="i18n.com_action" min-width="150px" v-if="!!tableColumn.length && i18n.com_action">
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="editPayment(scope.$index,scope.row)">{{i18n.com_edit}}</el-button>
              <el-button type="text" size="mini" @click="deletePayment(scope.$index, scope.row)">{{i18n.com_delete}}</el-button>
            </template>
          </el-table-column>
        </custom-table>
      </el-form>
    </div>
    <div class="btn-group" v-if="backType !== 'changeFirstpay'">
      <el-button @click="onCancel">{{i18n.com_cancel}}</el-button>
      <!-- 期末续租  试用转租赁-->
      <template v-if="backType === 'continueRent' || backType === 'testToRent'">
        <el-button @click="preStep">{{ i18n.page_content_previous_service_center_information }}</el-button>
        <el-button type="primary" @click="savePayment" v-if="contractInfo.signingMethod === 2">{{ i18n.page_content_next_step_upload_paper_contract }}</el-button>
        <el-button type="primary" @click="savePayment" v-if="contractInfo.signingMethod === 1">{{ i18n.page_content_next_step_choose_electronic_contract }}</el-button>
      </template>
      <template v-else-if="backType === 'order'">
        <el-button @click="preStep">{{ i18n.page_content_previous_parts_consumables }}</el-button>
        <el-button type="primary" @click="savePayment" v-if="contractInfo.signingMethod === 2">{{ i18n.page_content_next_step_upload_paper_contract }}</el-button>
        <el-button type="primary" @click="savePayment" v-if="contractInfo.signingMethod === 1">{{ i18n.page_content_next_step_choose_electronic_contract }}</el-button>
      </template>
      <template v-else>
        <el-button @click="preStep">{{ i18n.page_content_previous_lease_plan }}</el-button>
        <el-button type="primary" @click="savePayment" v-if="contractInfo.signingMethod === 2">{{ i18n.page_content_next_step_upload_paper_contract }}</el-button>
        <el-button type="primary" @click="savePayment" v-if="contractInfo.signingMethod === 1">{{ i18n.page_content_next_step_choose_electronic_contract }}</el-button>
      </template>
    </div>
    <!-- 填写首付款信息 -->
    <contract-paymentItem-dialog
      v-if="dialogVisible"
      :model="dialogModel"
      :contractId="contractId"
      :contractClass="contractClass"
      :operateFlag="operateFlag"
      :firstTotal="firstTotal"
      :hqProfitTotal="hqProfitTotal"
      :serviceProfitTotal="serviceProfitTotal"
      @close="dialogVisible = false"
      @addItem="addPaymentItem"
    ></contract-paymentItem-dialog>
    <!-- 图片 -->
    <img-detail-dialog
      :bizData="certificateData"
      :imgData="imgPreviewData"
      :title="i18n.dialog_title_transaction_certificate"
      v-if="visible"
      @close="visible = false"
    ></img-detail-dialog>
  </div>
</template>

<script>
/*
合同添加首付款
页面暂时用不上
bizType: 'certificate'也作废
*/
import apis from '@/utils/apis';
import languageInjectMixins from '@/mixins/language_inject_mixins';
// import contractPaymentDialog from './contract_payment_dialog.vue';

import contractPaymentTable from './contract_payment_table.vue';
import contractPaymentItemDialog from './contract_paymentItem_dialog.vue';

export default {
  components: { contractPaymentTable, contractPaymentItemDialog, },
  mixins: [languageInjectMixins],
  props: {
    backType: { type: String, default: '' },
    contractId: [String, Number],
    contractClass: [String, Number],
    operateFlag: [String, Number],
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
  },

  data() {
    return {
      tableCode: 'contract_payment_pay',
      isLoading: false,
      schemeList: [],
      totalRows: null,
      visible: false,
      imgPreviewData: [],
      certificateData: [],
      form: {
        isPrepayment: '0',
      },
      paymentList: [],
      deletePaymentList: [],
      // 选择收货地址
      dialogVisible: false,
      dialogModel: {},

      firstTotal: '', // 首期乙方应付合计
      hqProfitTotal: '', // 首期甲方应付总部合计
      serviceProfitTotal: '', // 首期甲方应付售后合计
    };
  },
  mounted() {
    this.getTableColumn();
    this.getListScheme();
    this.getPaymentList();
    // this.paymentList.push(this.PayItem);
  },
  methods: {
    getListScheme: function () {
      this.$getJSON(apis.crmContractListScheme, { bizId: this.contractId, bizClass: this.contractClass }).then((res) => {
        const data = res.data;
        const schemeList = data.goodsList || [];
        schemeList.forEach((i) => {
          i.hqShipTo = `${i.hqShipTo}`;
        });
        this.schemeList = schemeList;
        // if (this.schemeList.length) {
        //   this.form.isPrepayment = '1';
        // }
        this.firstTotal = data.firstTotal; // 首期乙方应付合计
        this.hqProfitTotal = data.hqProfitTotal; // 首期甲方应付总部合计
        this.serviceProfitTotal = data.serviceProfitTotal; // 首期甲方应付售后合计
      });
    },
    // 首付款列表
    getPaymentList() {
      this.$getJSON(apis.crmContractGetPrepayment, {
        bizId: this.contractId,
        bizClass: this.contractClass,
      }).then((res) => {
        // this.partAReceive = res.data.partAReceive;
        // this.serviceReceive = res.data.serviceReceive;

        const data = res.data.detailList || [];
        // 首付款状态，0-未付，1-租赁方已付，2-代理公司垫付
        data.forEach((i) => {
          i.type = `${i.type}`;
        });
        this.paymentList = data;
        // 首付款默认是否
        if (this.paymentList.length) {
          this.form.isPrepayment = '1';
        }
      });
    },
    // 取消
    onCancel: function () {
      // this.jump('/contract/management', { refresh: true }, true);
      this.$emit('cancelJump');
    },
    // 添加
    addPayMent: function () {
      // this.schemeDrawer = true;
      this.dialogVisible = true;
      this.dialogModel.title = this.i18n.msg_tips_add_pay_ment;
      this.dialogModel.contractId = this.contractId;
      this.dialogModel.contractClass = this.contractClass;
      this.dialogModel.operateFlag = this.operateFlag;
      this.dialogModel.type = 'add';
    },
    //
    editPayment: function (index, row) {
      this.dialogVisible = true;
      this.dialogModel.title = this.i18n.msg_tips_add_pay_ment;
      this.dialogModel.contractId = this.contractId;
      this.dialogModel.contractClass = this.contractClass;
      this.dialogModel.operateFlag = this.operateFlag;
      this.dialogModel.type = 'edit';
      this.dialogModel.index = index;
      // this.dialogModel.data = this.PayItem;
      this.dialogModel.data = row;
    },

    deletePayment: function (index, row) {
      this.$showConfirm(this.i18n.cf_tips_is_del_pay_ment)
        .then(() => {
          this.paymentList.splice(index, 1);
          this.deletePaymentList.push({ ...row, isDeleted: true });
        })
        .catch(() => {});


    },
    onViewCredentials: function (row) {
      this.certificateData = [{
        bizId: row.tradeId,
        bizType: 'certificate'
      }];
      this.imgPreviewData = row.attachList;
      // console.log(this.certificateData);
      this.visible = true;
    },
    addPaymentItem: function (item) {
      if (this.dialogModel.type === 'edit') {
        this.paymentList.splice(this.dialogModel.index, 1, item);
        // this.paymentList.push(item);
      } else {
        this.paymentList.push(item);
      }
    },
    // 首付款信息
    savePayment: function () {
      if (this.form.isPrepayment === '1') {
        if (this.paymentList.length) {


          // let firstTotal = 0; // 首期乙方应付合计
          // let hqProfitTotal = 0; // 首期甲方应付总部合计
          // let serviceProfitTotal = 0; // 首期甲方应付售后合计

          // this.paymentList.forEach((item) => {
          //   if (item.type === '1') {
          //     firstTotal += Number(item.totalAmount);
          //   } else if (item.type === '2') {
          //     hqProfitTotal += Number(item.totalAmount);
          //   } else {
          //     serviceProfitTotal += Number(item.totalAmount);
          //   }
          // });
          // console.log(firstTotal.toFixed(2), hqProfitTotal.toFixed(2), serviceProfitTotal.toFixed(2));
          // return;

          //   const value = Number(curr);
          //   if (!Number.isNaN(value)) {
          //     return prev + curr;
          //   } else {
          //     return prev;
          //   }
          // }).toFixed(0);
          const hasEmpty = this.paymentList.find(
            t => t.type === '2'
          );
          if (!hasEmpty && this.contractInfo.partyAId !== this.contractInfo.hqId) {
            this.$message.error(this.i18n.msg_tips_please_please_register_PartyA_representative_pay_factory);
            return;
          }
          //
          const params = {};
          params.operateFlag = this.operateFlag;
          params.bizId = this.contractId;
          params.bizClass = this.contractClass;
          params.detailList = [...this.paymentList, ...this.deletePaymentList];

          this.$postJSON(apis.crmContractSavePrepayment, params).then((res) => {
            if (res.code === 0) {
              this.$message({
                message: this.i18n.com_save_success,
                type: 'success',
              });
              this.$message({
                message: this.i18n.com_save_success,
                type: 'success',
              });
              this.$emit('success', 5);
            }
          });
        // this.$emit('success', 5);
        } else {
          this.$message({
            message: this.i18n.msg_tips_success,
            type: 'error',
          });
        }
      } else {
        //
        const paymentList = this.paymentList.map((i) => {
          let item = {};
          item = i;
          item.isDeleted = true;
          return item;
        });
        const params = {};
        params.operateFlag = this.operateFlag;
        params.bizId = this.contractId;
        params.bizClass = this.contractClass;
        params.detailList = [...paymentList, ...this.deletePaymentList];
        params.isPrepayment = false;
        this.$postJSON(apis.crmContractSavePrepayment, params).then(() => {
          this.$message({
            message: this.i18n.com_save_success,
            type: 'success',
          });
          this.$emit('success', 5);
        });
      }
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import '@/style/colors.scss';
.content-payment {
  padding: 14px 24px 0;
  .total-line {
    color: #6c757d;
  }
}
</style>
